import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {compareTimeslotStartEnd} from '../components/Utils';
import {Timeslot} from '../shared/Timeslot';
import {MiniBookAdminService} from './mini-book-admin.service';

export class TimeslotService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getTimeslots(): Observable<Timeslot[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/timeslots`).pipe(
      map<any[], Timeslot[]>(data => data.map(value => Timeslot.createFromJson(value))),
      map(ts => ts.sort(compareTimeslotStartEnd))
    );
  }

  createTimeslot(timeslot: Timeslot): Observable<Timeslot> {
    return this.http.post<any>(`${this.adminService.tenant}/timeslots`, timeslot.toJson()).pipe(
      map<any, Timeslot>(data => Timeslot.createFromJson(data))
    );
  }

  getTimeslot(id: number): Observable<Timeslot> {
    return this.http.get<any>(`${this.adminService.tenant}/timeslots/${id}`).pipe(
      map<any, Timeslot>(data => Timeslot.createFromJson(data))
    );
  }

  updateTimeslot(id: number, timeslot: Timeslot): Observable<Timeslot> {
    return this.http.put<any>(`${this.adminService.tenant}/timeslots/${id}`, timeslot.toJson()).pipe(
      map<any, Timeslot>(data => Timeslot.createFromJson(data))
    );
  }

  deleteTimeslot(id: number, forced: boolean): Observable<void> {
    let force = "";
    if (forced) {
      force = "?force=true";
    }
    return this.http.delete<void>(`${this.adminService.tenant}/timeslots/${id}${force}`);
  }
}
